import React from "react";
import {Link} from "react-router-dom";
import { CURRENT_YEAR, CURRENT_MONTH_SHORT } from "../../utils/constants.js";

import IconBestCat from "../../assets/images/best-cat.svg"
import IconCollege from "../../assets/images/college-cat.svg"
import IconLimitedCredit from "../../assets/images/limitedcredit-cat.svg"
import IconFrequentTraveler from "../../assets/images/frequenttraveler-cat.svg"

import IconDining from "../../assets/images/dining-LP.svg";
import IconGroceries from "../../assets/images/grocery-LP.svg";
import IconTravel from "../../assets/images/travel-LP.svg";
import IconGas from "../../assets/images/gas-LP.svg";
import IconRecreation from "../../assets/images/recreation-LP.svg";

import "./LinkPanels.scss";


const LinkPanels = (props) => {

     //
     const {
          isShowTop=true,
          cardsBySpendTitle="Find Credit Cards by Spend"
     } = props;
     
     //
     return (
          <div style={{display: "flex"}}>
               <div className="link-panels-container">

                    {isShowTop?
                         <div className="link-panels-category">
                              <h2 className="link-panels-title">
                                   Find Credit Cards by Category
                              </h2>
                              <div className="link-panels-top">
                                   <LinkPanel {...{isTop: true, linkTo: "/current-best-cards", iconSrc: IconBestCat, title: 
                                        (<>
                                             <div>Best Credit Cards</div>
                                             <div>{CURRENT_MONTH_SHORT} {CURRENT_YEAR}</div>
                                        </>)
                                   }}/>
                                   <LinkPanel {...{isTop: true, linkTo: "/best-credit-cards/college-students", iconSrc: IconCollege, title: "College Students"}}/>
                                   <LinkPanel {...{isTop: true, linkTo: "/best-credit-cards/limited-credit", iconSrc: IconLimitedCredit, title: "Limited Credit"}}/>
                                   <LinkPanel {...{isTop: true, linkTo: "/best-credit-cards/frequent-travelers", iconSrc: IconFrequentTraveler, title: "Frequent Travelers"}}/>
                              </div>
                         </div>
                         : null
                    }

                    <div className="link-panels-spend">
                         <h2 className="link-panels-title">
                              {cardsBySpendTitle}
                         </h2>
                         <div className="link-panels">
                              <LinkPanel {...{iconSrc: IconDining, linkTo: "/best-credit-cards/dining-and-entertainment-spend", title: "Dining", text: "Maximize restaurant and delivery"}}/>
                              <LinkPanel {...{iconSrc: IconGroceries, linkTo: "/best-credit-cards/grocery-shopping-spend", title: "Groceries", text: "Daily cash back on essentials"}}/>
                              <LinkPanel {...{iconSrc: IconTravel, linkTo: "/best-credit-cards/travel-spend", title: "Travel", text: "Points that actually get you there"}}/>
                              <LinkPanel {...{iconSrc: IconRecreation, linkTo: "/best-credit-cards/entertainment-and-recreation-spend", title: "Entertainment", text: "From movies to museums to subscriptions"}}/>
                              <LinkPanel {...{iconSrc: IconGas, linkTo: "/best-credit-cards/gas-and-fuel-spend", title: "Gas & Fuel", text: "Every drive adds up"}}/>
                         </div>
                    </div>
               </div>
          </div>
     );
};

// 
const LinkPanel = (props) => {

     //
     const { iconSrc, title, text, isTop, linkTo } = props;

     //
     return (
          <Link to={linkTo} style={{textDecoration: "none"}}>
               <div className={isTop? "link-panel-top" : "link-panel-bottom"}>
                    <div className="icon-container">
                         <img src={iconSrc}/>
                    </div>
                    <div className="link-panel-mainarea">
                         <div className="link-panel-title">
                              {title}
                         </div>
                         <div className="link-panel-text">
                              {text}
                         </div>
                    </div>
               </div>
          </Link>
     );
}



export default LinkPanels;
